import { RedirectToSignIn, useAuth } from '@clerk/react'
import type { ReactNode } from 'react'
import { useLocation } from '#router'
import { useFeatureFlag } from '@/hooks/use-feature-flag'
import LoadingFallback from './loading-fallback'
import NotFound from './not-found'

interface FeatureFlagRouteProps {
  flag: string
  children: ReactNode
}

/**
 * Route guard that checks a PostHog feature flag.
 * - Flag on -> render children (requires auth)
 * - Flag off + admin -> render children (admin bypass)
 * - Flag off + non-admin -> 404
 */
export function FeatureFlagRoute({ flag, children }: FeatureFlagRouteProps) {
  const { isLoaded: authLoaded, isSignedIn } = useAuth()
  const { enabled, isLoaded: flagLoaded } = useFeatureFlag(flag)
  const location = useLocation()
  const currentPathWithSearch = `${location.pathname}${location.search}`

  if (!authLoaded || !flagLoaded) {
    return <LoadingFallback />
  }

  if (!isSignedIn) {
    return <RedirectToSignIn redirectUrl={currentPathWithSearch} />
  }

  if (!enabled) {
    return <NotFound />
  }

  return <>{children}</>
}
